import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  light?: boolean;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  actionLabel,
  actionTo,
  light = false,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
      <div>
        {kicker ? (
          <p
            className={`mb-2 flex items-center gap-2 font-label text-[11px] font-semibold uppercase tracking-[0.22em] ${
              light ? "text-secondary-400" : "text-accent-600"
            }`}
          >
            <span className={`h-[2px] w-6 ${light ? "bg-secondary-400" : "bg-accent-500"}`} />
            {kicker}
          </p>
        ) : null}
        <h2
          className={`font-heading text-xl font-semibold tracking-tight md:text-2xl ${
            light ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {description ? (
          <p
            className={`mt-2 max-w-2xl text-sm leading-relaxed ${
              light ? "text-background-300" : "text-foreground-600"
            }`}
          >
            {description}
          </p>
        ) : null}
      </div>

      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className={`group flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border px-3 py-2 text-xs font-medium transition-colors duration-300 ${
            light
              ? "border-background-50/25 text-background-100 hover:border-secondary-400 hover:text-secondary-300"
              : "border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
          }`}
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-0.5" />
        </Link>
      ) : null}
    </div>
  );
}